<template>
  <div class="page-index">
    <div class="index-body flex">
      <div class="index-content">
        <div class="content">
          <page-assets></page-assets>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageAssets from "./assets.vue";
export default {
  data() {
    return {};
  },
  components: {
    PageAssets,
  },
  methods: {}
};
</script>

<style lang="scss">
.page-index {
  height: 100%;
  color: #7c8d9d;
  height: 0.56rem;
  input {
    color: #606266;
  }
  .title-scales-power {
    margin-right: 0.2rem;
    padding-left: 0.24rem;
    .text-scales {
      color: #0276e3;
      font-size: 0.3rem;
    }
    .text-power {
      color: #03c4c6;
      font-size: 0.2rem;
    }
  }
  .logo-img-box {
    border-bottom: 1px solid #e5e9ec;
    height: 0.54rem;
    margin-bottom: 0.2rem;
  }
  .logo-img {
    width: 0.9rem;
  }
  aside {
    height: 100%;
    width: 1.2rem;
    flex-shrink: 0;
    color: rgba(255, 255, 255, 0.4);
    text-align: center;
    position: relative;
    border-right: 1px solid #e5e9ec;
    background-color: #0f59a8;
    div {
      &.active {
        color: #fff;
      }
    }
    p {
      margin-bottom: 0.2rem;
      margin-top: 0.04rem;
      font-size: 0.14rem;
    }
    .setting-box {
      bottom: 0.2rem;
      width: 100%;
      .add-site-box {
        position: absolute;
        background-color: #000;
        border: 1px solid #393c47;
        width: 100%;
        right: 0;
        top: 50%;
        transform: translate(70%, -50%);
        font-size: 0.14rem;
        padding: 0.1rem;
        border-radius: 6px;
      }
    }
  }
  .index-body {
    height: 100%;
  }
  .index-content {
    width: 100%;
    & > .content {
      height: 100%;
      & > div {
        width: 100%;
        height: 100%;
      }
    }
  }
  .modal {
    .modal-body {
      background-color: #fff;
    }
  }
  .delete-modal {
    .modal-body {
      width: 8rem;
      padding: 0.4rem 0;
      text-align: center;
      p {
        margin-bottom: 0.2rem;
      }
    }
  }
}
</style>
